import React, { useState } from 'react';
import { usePageTitle } from '../../hooks/usePageTitle';
import RelatorioVendas from './RelatorioVendas';
import RelatorioEncomendas from './RelatorioEncomendas';

type TabType = 'vendas' | 'encomendas';

const Relatorios: React.FC = () => {
  usePageTitle('Relatórios');
  const [activeTab, setActiveTab] = useState<TabType>('vendas');

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Relatórios</h1>

      {/* Tabs */}
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            <button
              onClick={() => setActiveTab('vendas')}
              className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
                activeTab === 'vendas'
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Relatório de Vendas (PDV)
            </button>
            <button
              onClick={() => setActiveTab('encomendas')}
              className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
                activeTab === 'encomendas'
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Relatório de Encomendas
            </button>
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'vendas' && <RelatorioVendas />}
      {activeTab === 'encomendas' && <RelatorioEncomendas />}
    </div>
  );
};

export default Relatorios;
